var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 1.66675V11.6667C9.16667 14.4245 8.59108 15.0001 5.83333 15.0001H2.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16675 10H9.16675",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 13.3333H15.4166M14.5833 15.8333H15.4166",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 4.16675V18.3334H3.56591C2.53165 18.3334 2.01453 18.3334 1.7762 17.9789C1.53786 17.6244 1.7135 17.1165 2.06478 16.1007L6.48518 3.31764C6.76111 2.51966 6.89909 2.12068 7.20865 1.89371C7.51822 1.66675 7.92444 1.66675 8.73691 1.66675H9.27275C10.4012 1.66675 10.9656 1.66675 11.3162 2.03286C11.6667 2.39898 11.6667 2.98824 11.6667 4.16675Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 8.33325L14.8248 9.32017C16.5162 9.84867 17.3618 10.113 17.8477 10.7738C18.3334 11.4345 18.3334 12.3205 18.3334 14.0925V16.6666C18.3334 17.4523 18.3334 17.8451 18.0893 18.0892C17.8452 18.3333 17.4524 18.3333 16.6667 18.3333H11.6667",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyType);
export default __webpack_public_path__ + "static/media/company-type.f78bbf570ac095ca147cd282a5a205f1.svg";
export { ForwardRef as ReactComponent };